import * as security from "utils/security";

const CREDENTIALS = "same-origin";

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export function buildLocalUrl(path: string, params: Object) {
  var url = new URL(path, window.location.origin);
  if (params) {
    Object.entries(params).forEach(([name, value]) => url.searchParams.set(name, value.toString()));
  }
  return url;
}

export function httpDelete(url: string, params = {}) {
  return fetch(url + new URLSearchParams(params), {
    credentials: CREDENTIALS,
    headers: {
      ...csrfHeaders(),
      ...JSON_HEADERS,
    },
    method: "DELETE",
  });
}

export function httpGet(url: string, params = null) {
  return fetch(buildLocalUrl(url, params), {
    credentials: CREDENTIALS,
    headers: JSON_HEADERS,
    method: "GET",
  });
}

export function httpPatch(url: string, body = {}) {
  return fetch(url, {
    body: JSON.stringify(body),
    credentials: CREDENTIALS,
    headers: {
      ...csrfHeaders(),
      ...JSON_HEADERS,
    },
    method: "PATCH",
  });
}

export function httpPost(url: string, body = {}) {
  return fetch(url, {
    body: JSON.stringify(body),
    credentials: CREDENTIALS,
    headers: {
      ...csrfHeaders(),
      ...JSON_HEADERS,
    },
    method: "POST",
  });
}

export function buildClient(responseInterceptor = (response: Response) => response) {
  return {
    async httpDelete(url: string, params = {}) {
      return httpDelete(url, params).then(responseInterceptor);
    },
    async httpGet(url: string, params = null) {
      return httpGet(url, params).then(responseInterceptor);
    },
    async httpPatch(url: string, body = {}) {
      return httpPatch(url, body).then(responseInterceptor);
    },
    async httpPost(url: string, body = {}) {
      return httpPost(url, body).then(responseInterceptor);
    },
  };
}

function csrfHeaders() {
  return {
    "X-CSRF-Token": security.getCsrfToken(),
  };
}
